import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import environments from '@/store/modules/environment'

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        environments
    },
    strict: true,
})
